import React from "react"

export default function Company() {
    return (
        <div>
            <img                
                src={require(`./assets/company.jpg`)}
                alt={'company'}
                style={{
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto' 
                }}
            />
        </div>
    )
}